import { combineReducers } from "redux";

import overviewReducer from "@src/components/Tabs/Overview/store/reducer";
import courseContentReducer from "@src/components/Tabs/Content/store/reducer";
import courseLiveClassReducer from "@src/components/Tabs/LiveClasses/store/reducers";
import layoutReducer from "@src/layout/store/reducer";
import tabBarReducer from "@src/components/UIElements/TabBar/store/reducer";

import persistedDataReducer from "./persistedData";
import bottomSheetReducer from "@src/components/BottomSheets/store/reducer";
import upcomingClassesReducer from "@src/components/BottomSheets/components/UpcomingClassModal/store/reducer";
import announcementsReducer from "@src/components/Tabs/Announcements/store/reducer";
import physicalShipmentReducer from "@src/components/PhysicalAddress/store/reducer";
import pullToRefreshReducer from "@src/components/PullToRefresh/store";

const rootReducer = combineReducers({
  persistedDataReducer: persistedDataReducer,
  pullToRefreshReducer: pullToRefreshReducer,
  overviewReducer: overviewReducer,
  courseContentReducer: courseContentReducer,
  bottomSheetReducer: bottomSheetReducer,
  courseLiveClassReducer: courseLiveClassReducer,
  layoutReducer: layoutReducer,
  globalReducer: layoutReducer,
  tabBarReducer: tabBarReducer,
  upcomingClassesReducer: upcomingClassesReducer,
  announcementsReducer: announcementsReducer,
  physicalShipmentReducer: physicalShipmentReducer,
});

export default rootReducer;
